import React from 'react';
import { withRouter } from 'dva/router';
import { connect } from 'dva';
import './index.less';

function SiderMenu() {
  // useEffect(() => {
  //   if (menuItem.length > 0) {
  //     menuItem.some(item => {
  //       const { id: mainId, items } = item;

  //       return items.some(({ id, type, m_url }) => {
  //         if (props.location.pathname === '/old/system/' + id && type === '1') {
  //           setMenuOpenKeys([mainId]);
  //           return true;
  //         } else if (props.location.pathname === m_url && type === '2') {
  //           setTimeout(() => setMenuOpenKeys([mainId]), 200);
  //           return true;
  //         }
  //       });
  //     });
  //   }
  // }, [props.location.pathname, menuItem]);

  // useEffect(() => {
  //   systemUserInfoApi().then(res => {
  //     const { flag, data } = res;

  //     if (flag === 200) {
  //       const { code_list, menu_list } = data;

  //       setMenuItem(menu_list);

  //     }
  //   });
  //   let menuList = window.localStorage.getItem('menuList');

  //   if(!menuList){
  //     //window.location.href = '/login';
  //   }

  //   menuList = JSON.parse(menuList);
  //   setMenuItem(menuList);
  // }, []);

  // const onTitleClick = ({ key }) => {
  //   setMenuOpenKeys(menuOpenKeys[0] === key ? [''] : [key]);
  // };

  // const selectPathnameMemo = useMemo(()=>{
  //   //在路由不是当前菜单的路由时候仍要使当前路由高亮~
  //   const pathName = props.location.pathname;

  //   let finalName = '';

  //   if(pathName.indexOf('/goods/replenish') > -1){
  //     finalName = '/goods/replenish';
  //   }else if(pathName.indexOf('/operation/ads') > -1 && pathName.indexOf('position') === -1){
  //     finalName = '/operation/ads';
  //   }else if(pathName.indexOf('/system/user-roles/edit') > -1){
  //     finalName = '/system/user-roles';
  //   }else if(pathName.indexOf('/trading/order') > -1){
  //     finalName = '/trading/order';
  //   }else{
  //     finalName = pathName;
  //   }

  //   return finalName;
  // },[props.location.pathname])

  return <div className="side-bar-div"></div>;
}

const mapStateToProps = state => {
  const { menu = {} } = state;
  const { collapsed = false } = menu;

  return { collapsed };
};

export default withRouter(connect(mapStateToProps)(SiderMenu));
